var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import DOMPurify from 'dompurify';
import QuestionnaireOrg from "../../../organisms/obligationsQuestionnaire/obligationsQuestionnaire";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { AdviserClientObligationsAction, AdviserClientObligationsFormAction, ResetAdviserGlobalFormAction, ResetAdviserJobseekerOutcomeFormAction, ResetAdviserProgressionMilestoneFormAction, } from "../../../../redux/actions/adviser_questionnaire";
import { getAdviserQuestionnaireProgressWidth } from "../../../../utils/questionnaireProgress";
/**
 * The Adviser Client Obligations Questionnaire Page
 * This will need to call all relevant APIs to get the values.
 * @param props
 * @returns
 */
function AdviserClientObligationsQuestionnaire() {
    var navigate = useNavigate();
    var dispatch = useDispatch();
    var _a = useState(''), error = _a[0], setError = _a[1];
    //using selector hook to fetch data from the reducer
    var _b = useSelector(function (state) { return state.rootReducer.AdviserQuestionnaireReducer; }), adviserClientObligationsData = _b.adviserClientObligationsData, error_adviserClientObligationsl = _b.error_adviserClientObligationsl, loading = _b.loading, adviserClientObligationsFormData = _b.adviserClientObligationsFormData, success_adviserClientObligations_form = _b.success_adviserClientObligations_form;
    useEffect(function () {
        // Adviser Progression prefetches this section already; only fetch if it's
        // not already cached in the store (e.g. direct navigation to this page).
        if (!adviserClientObligationsData || adviserClientObligationsData.length === 0) {
            dispatch(AdviserClientObligationsAction());
        }
    }, [dispatch]);
    var loginData = useSelector(function (state) { return state.rootReducer.userReducer; }).loginData;
    var quesAttemptDetails = useSelector(function (state) { return state.rootReducer.dashboardReducer.quesAttemptDetails; });
    var isSecondAttempt = !!(quesAttemptDetails === null || quesAttemptDetails === void 0 ? void 0 : quesAttemptDetails.adv_questionnaire_one_complete);
    //function to submit the input user data
    var handleFormSubmit = function (formData) {
        var sanitizedData = Object.keys(formData).reduce(function (acc, key) {
            acc[key] = DOMPurify.sanitize(formData[key]);
            return acc;
        }, {});
        dispatch(AdviserClientObligationsFormAction(sanitizedData, loginData));
    };
    var handleBackBtn = function () {
        // Clear the stale "form just submitted" flag on the target page so its
        // own success effect doesn't immediately auto-navigate us forward again.
        if ((quesAttemptDetails === null || quesAttemptDetails === void 0 ? void 0 : quesAttemptDetails.milestone_questionnaire_ready) &&
            !(quesAttemptDetails === null || quesAttemptDetails === void 0 ? void 0 : quesAttemptDetails.adv_milestone_questionnaire_complete)) {
            dispatch(ResetAdviserProgressionMilestoneFormAction());
            navigate("/questionnaire/adviserProgressionMilestone");
        }
        else if (isSecondAttempt) {
            dispatch(ResetAdviserJobseekerOutcomeFormAction());
            navigate("/questionnaire/adviserJobseekerOutcome");
        }
        else {
            dispatch(ResetAdviserGlobalFormAction());
            navigate("/questionnaire/adviserGlobal");
        }
    };
    if (success_adviserClientObligations_form) {
        navigate("/questionnaire/adviserAdviserObligations");
    }
    return (_jsxs("div", __assign({ className: "" }, { children: [error && _jsx("div", __assign({ className: "error-message" }, { children: error })), _jsx(QuestionnaireOrg, { title: "Customer Expectations", content: "As an adviser on this programme, you will be interacting with your customer on a regular basis. In order to ensure that you get the best from the relationship with your customer, we want to understand what you feel you have committed to do, but also what they have committed to do, to develop their employability. Please respond truthfully and trust your initial reactions to the following statements.", data: adviserClientObligationsData, responses: adviserClientObligationsFormData, loading: !adviserClientObligationsData || adviserClientObligationsData.length === 0, handleSubmit: handleFormSubmit, handleBackBtn: handleBackBtn, classname: "global-w", width: getAdviserQuestionnaireProgressWidth("adviserClientObligations", isSecondAttempt) })] })));
}
export default AdviserClientObligationsQuestionnaire;
